/* istanbul ignore file  */

/**
 * 這支檔案的測試價值低，所以不測：
 * - 本身不影響功能
 * - 需要 mock window.location
 * - 需要 mock onCLS onFID onLCP onINP
 * - 需要 mock gtag
 */
import { onCLS, onFID, onINP, onLCP } from 'web-vitals';
import {
  sendGaEventToInstoreOrdering,
  sendGaEventToOnlineRestaurant,
  sendGaEventToStoreBrowser,
  sendGaEventToReservation,
} from './ga4';

function sendMetricsToGa({ name, value, delta, id, ...others }) {
  const { pathname } = window.location;
  const params = {
    value: delta,
    metricId: id,
    originalValue: value,
    originalDelta: delta,
    ...others,
  };

  /**
   * TODO:
   * 之後可能會越來越難判斷該在送事件去哪個 GA4 target
   * e.g. 目前優惠券相關事件預設都會送到外帶 target
   * 如果未來內用也有優惠券，那領取優惠券的事件要送到哪裡？
   * 這裡暫時先用 url 路徑來判斷該送到哪，如果不確定就都送到外帶
   * 但這是不精確的。
   */
  if (pathname.includes('campaign')) {
    sendGaEventToStoreBrowser(name, params);
  } else if (pathname.includes('instore')) {
    sendGaEventToInstoreOrdering(name, params);
  } else if (pathname.includes('reserve')) {
    sendGaEventToReservation(name, params);
  } else {
    sendGaEventToOnlineRestaurant(name, params);
  }
}

/**
 * 監聽 web-vital 的效能指標，並在觀察到指標時送 event 到 GA。
 * 目前會監聽 LCP / FID / CLS。
 * 會依據目前的網址判斷要送到哪個 GA target。
 * 這是為了驗證效能對使用者行為 / bounce rate 的影響。
 *
 * @see https://github.com/GoogleChrome/web-vitals
 */
export default function registerPerfEventForGA() {
  onLCP(sendMetricsToGa);
  onFID(sendMetricsToGa);
  onCLS(sendMetricsToGa);
  onINP(sendMetricsToGa);
}
